import { createAction, props } from '@ngrx/store';

import {
  IPageOfPropertyInput,
  IPageOfProperty,
} from '@shared/models/properties';
import { IOrganization } from '@shared/models/organization';

export const resetOrganizationAction = createAction('[Organization] Reset');

export const fetchOrganizationPropertiesAction = createAction(
  '[Organization] Fetch Organization Properties',
  props<IPageOfPropertyInput>()
);

export const fetchOrganizationPropertiesActionSuccess = createAction(
  '[Organization] Fetch Organization Properties Success',
  props<IPageOfProperty>()
);

export const fetchOrganizationPropertiesActionFailure = createAction(
  '[Organization] Fetch Organization Properties Failure'
);

export const setOrganizationUrlSlugAction = createAction(
  '[Organization] Set Organization URL Slug',
  props<{ slug: string | null }>()
);

export const setLastOrganizationUrlSlugAction = createAction(
  '[Organization] Set Last Organization URL Slug',
  props<{ slug: string | null }>()
);

export const getOrganizationByShortNameAction = createAction(
  '[Organization] Get Organization By Short Name',
  props<{
    shortName: string;
    campaignName?: string | null;
    refCode?: string | null;
  }>()
);
export const getOrganizationByShortNameActionSuccess = createAction(
  '[Organization] Get Organization By Short Name Success',
  props<{ organization: IOrganization }>()
);
export const getOrganizationByShortNameActionFailure = createAction(
  '[Organization] Get Organization By Short Name Failure'
);
